import React, { useEffect, useState } from "react";

export default function Queue() {
  const API = "https://app.saravanabhava.in/queue.php";

  const [queue, setQueue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchQueue = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API}?action=list&filter=${filter}&search=${search}&page=${page}`
      );
      const data = await res.json();

      if (data.success && Array.isArray(data.queue)) {
        setQueue(data.queue);
        setTotalPages(data.totalPages || 1);
      } else {
        setQueue([]);
        setTotalPages(1);
      }
    } catch (err) {
      console.error("Fetch queue error", err);
      setQueue([]);
      setTotalPages(1);
    }
    setLoading(false);
  };

  const sendNow = async (id) => {
    if (!window.confirm("Send this mail now?")) return;
    try {
      const res = await fetch(`${API}?action=sendNow`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.success) {
        alert("Mail sent successfully ✅");
        fetchQueue();
      } else {
        alert("Failed to send ❌");
      }
    } catch (err) {
      console.error("SendNow error", err);
    }
  };

  const sendAll = async () => {
    if (!window.confirm("Send all pending mails now?")) return;
    try {
      const res = await fetch(`${API}?action=sendAll`, { method: "POST" });
      const data = await res.json();
      if (data.success) {
        alert(`✅ Sent ${data.sent || 0} mails`);
        fetchQueue();
      }
    } catch (err) {
      console.error("SendAll error", err);
    }
  };

  const deleteOne = async (id) => {
    if (!window.confirm("⚠️ Delete this mail from queue?")) return;
    try {
      const res = await fetch(`${API}?action=deleteOne`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.success) {
        alert("🗑️ Mail deleted");
        fetchQueue();
      } else {
        alert("❌ Failed to delete");
      }
    } catch (err) {
      console.error("DeleteOne error", err);
    }
  };

  const deleteAll = async () => {
    if (!window.confirm("⚠️ Delete ALL mails in queue? This cannot be undone.")) return;
    try {
      const res = await fetch(`${API}?action=deleteAll`, { method: "POST" });
      const data = await res.json();
      if (data.success) {
        alert("🗑️ All queue cleared");
        fetchQueue();
      } else {
        alert("❌ Failed to delete all");
      }
    } catch (err) {
      console.error("DeleteAll error", err);
    }
  };

  useEffect(() => {
    fetchQueue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, search, page]);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">📧 Mail Queue</h2>

      {/* Search + Filters */}
      <div className="flex gap-4 mb-4 items-center">
        <input
          type="text"
          placeholder="🔍 Search by email/subject"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          className="border p-2 rounded w-1/3"
        />
        {["all", "pending", "sent", "failed"].map((f) => (
          <button
            key={f}
            onClick={() => {
              setFilter(f);
              setPage(1);
            }}
            className={`px-3 py-1 rounded ${
              filter === f ? "bg-blue-600 text-white" : "bg-gray-300"
            }`}
          >
            {f.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Bulk Action */}
      <div className="mb-4 flex gap-2">
        <button
          onClick={sendAll}
          className="px-4 py-2 bg-green-600 text-white rounded"
        >
          🚀 Send All Pending
        </button>
        <button
          onClick={deleteAll}
          className="px-4 py-2 bg-red-600 text-white rounded"
        >
          🗑️ Delete All Queue
        </button>
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="w-full border-collapse border">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">ID</th>
              <th className="border p-2">Email</th>
              <th className="border p-2">Subject</th>
              <th className="border p-2">Status</th>
              <th className="border p-2">Created</th>
              <th className="border p-2">Sent</th>
              <th className="border p-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {queue.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center p-2">
                  No mails found
                </td>
              </tr>
            ) : (
              queue.map((mail) => (
                <tr key={mail.id || Math.random()}>
                  <td className="border p-2">{mail.id || "-"}</td>
                  <td className="border p-2">{mail.email || "-"}</td>
                  <td className="border p-2">{mail.subject || "-"}</td>
                  <td
                    className={`border p-2 ${
                      mail.status === "sent"
                        ? "text-green-600"
                        : mail.status === "failed"
                        ? "text-red-600"
                        : "text-yellow-600"
                    }`}
                  >
                    {mail.status || "-"}
                  </td>
                  <td className="border p-2">{mail.created_at || "-"}</td>
                  <td className="border p-2">{mail.sent_at || "-"}</td>
                  <td className="border p-2 flex gap-2">
                    {mail.status === "pending" && (
                      <button
                        onClick={() => sendNow(mail.id)}
                        className="px-3 py-1 bg-blue-600 text-white rounded"
                      >
                        Send Now
                      </button>
                    )}
                    <button
                      onClick={() => deleteOne(mail.id)}
                      className="px-3 py-1 bg-red-600 text-white rounded"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {/* Pagination */}
      <div className="flex justify-between items-center mt-4">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className="px-3 py-1 bg-gray-400 text-white rounded disabled:opacity-50"
        >
          ⬅ Prev
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
          className="px-3 py-1 bg-gray-400 text-white rounded disabled:opacity-50"
        >
          Next ➡
        </button>
      </div>
    </div>
  );
}
